import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { seoMeta, canonicalLink } from "@/lib/content-defaults";
import { Route as rootRoute } from "./__root";

// El contenido real vive en privacidad-page.tsx y se descarga aparte (code-split) — así visitar
// el home u otra página pública no baja el bundle de esta (ver mismo criterio en staff.tsx).
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/privacidad",
  head: () => ({
    meta: seoMeta({
      title: "Política de Privacidad — Calistenia Progresiva",
      description: "Cómo Calistenia Progresiva recopila, usa y protege tus datos personales.",
      path: "/privacidad",
    }),
    links: [canonicalLink("/privacidad")],
  }),
  component: lazyRouteComponent(() => import("./privacidad-page"), "PrivacidadPage"),
});
